// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"fa935388","81":"726ff400","961":"40287f9d"}[chunkId] + ".chunk.js";
};